import { createStore } from "zustand";
import { FALLBACK_BREAKPOINT } from "./fallbackMatchMediaUtils.js";
const breakpointKeyExists = {
    xs: true,
    sm: true,
    md: true,
    lg: true,
    xl: true
};
const MOBILE_BREAKPOINTS = [
    'xs',
    'sm'
];
const isMobileBreakpoint = (breakpoint)=>MOBILE_BREAKPOINTS.includes(breakpoint);
const isBreakpointsStoreLoaded = (breakpointsStore)=>!breakpointsStore.isLoading;
function setActiveBreakpoint(breakpoints, activeBreakpoint) {
    const keyedMatches = breakpoints.keys.reduce((result, breakpointKey)=>({
            ...result,
            [breakpointKey]: breakpointKey === activeBreakpoint
        }), {});
    return {
        isLoading: false,
        ...keyedMatches,
        activeBreakpoint,
        isMobile: isMobileBreakpoint(activeBreakpoint)
    };
}
const getFallbackBreakpointsStore = ()=>createStore()(()=>getFallbackBreakpointsStoreInitState());
const getFallbackBreakpointsStoreInitState = ()=>{
    const fallbackBreakpoints = Object.keys(breakpointKeyExists).reduce((result, breakpointKey)=>({
            ...result,
            [breakpointKey]: breakpointKey === FALLBACK_BREAKPOINT
        }), {});
    return {
        isLoading: false,
        ...fallbackBreakpoints,
        activeBreakpoint: FALLBACK_BREAKPOINT,
        isMobile: isMobileBreakpoint(FALLBACK_BREAKPOINT),
        setActiveBreakpoint: ()=>{}
    };
};
export { breakpointKeyExists, getFallbackBreakpointsStore, getFallbackBreakpointsStoreInitState, isBreakpointsStoreLoaded, isMobileBreakpoint, setActiveBreakpoint };

//# sourceMappingURL=breakpoint-provider-model.js.map